import { Fragment, useEffect, useRef, useState } from 'react'
import css from './completedMaintenanceEventsBlock.module.css'
import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import { IUser } from '@/pages/Users/users.types'
import timeUtils from '@/utils/time.utils'
import organizationsApi from '@/pages/Organizations/organizations.api'
import { IEquipmentMaintenanceBlank } from '@/pages/Equipment/equipment.types'
import CompletedMaintenanceEventItem from './components/CompletedMaintenanceEventItem'
import SeparateLine from '@/shared/Forms/SeparateLine'

import SkeletonCompletedMaintenanceEventList from './components/SkeletonCompletedMaintenanceEventList'
import { Virtuoso } from 'react-virtuoso'
import commonCss from '../../employePageContentBlock.module.css'
import cn from '@/utils/cn'

interface IProps {
  user: IUser
  loading: boolean
  periodInDays?: number
}

const CompletedMaintenanceEventsBlock = ({ periodInDays = 30, ...props }: IProps) => {
  const [maintenanceBlanks, setMaintenanceBlanks] = useState<IEquipmentMaintenanceBlank[]>([])
  const { wait, loading: maintenanceBlanksLoading } = useHttpLoader()
  const virtuosoRef = useRef()

  useEffect(() => {
    if (!props.user || props.loading) return
    const todayDate = new Date()
    todayDate.setHours(0)

    const params = {
      date_lte: todayDate.toISOString(),
      date_gte: timeUtils.subDays(todayDate, periodInDays).toISOString(),
      userId: props.user.id,
    }

    wait(organizationsApi.getMaintenanceStats(props.user.organizationId, params), (resp) => {
      if (resp.status === 'success') {
        setMaintenanceBlanks(resp.body.completedMaintenance.map((m) => ({ ...m, equipmentId: m.equipment.id })))
      }
    })
  }, [props.user])

  const renderFavouriteEquipmentList = () => {
    if (maintenanceBlanksLoading || props.loading) {
      return <SkeletonCompletedMaintenanceEventList />
    }

    if (!maintenanceBlanks.length)
      return (
        <div className="flex-lines center height100">
          <EmptyPlaceholder inscription="За последний месяц не было активности" />
        </div>
      )

    return (
      <Virtuoso
        ref={virtuosoRef}
        style={{ height: '100%', width: '100%', scrollbarWidth: 'thin' }}
        totalCount={maintenanceBlanks.length}
        itemContent={(index) => (
          <Fragment key={maintenanceBlanks[index].id}>
            <CompletedMaintenanceEventItem maintenanceBlank={maintenanceBlanks[index]} />
            {index !== maintenanceBlanks.length - 1 && <SeparateLine style={{ margin: '8px 0' }} />}
          </Fragment>
        )}
      />
    )
  }

  return (
    <div className={cn(css.wrapper, commonCss.commonBlockSizesWrapper)}>
      <h2 style={{ padding: '6px 8px' }} className="text-heading-4">
        Лента активности
      </h2>
      <div className={css.listWrapper}>{renderFavouriteEquipmentList()}</div>
    </div>
  )
}

export default CompletedMaintenanceEventsBlock
